import { FOOTER } from "../../../util/brand";
import { CookieSettingsLink } from "../../CookieConsent/CookieConsentBanner";

function FooterMain() {
  if (FOOTER.stripped) {
    return (
      <footer className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto flex justify-between items-center flex-wrap gap-4 p-5">
          <div className="footer-copyright">
            © 2025 {FOOTER.owner} · <a href={`mailto:${FOOTER.email}`}>{FOOTER.email}</a>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="border-t border-gray-200" role="contentinfo">
      <div className="max-w-7xl mx-auto flex justify-between items-center flex-wrap gap-4 p-5">
        <div className="footer-copyright text-sm text-gray-600">
          © 2025 {FOOTER.owner} — All Rights Reserved
        </div>
        <nav className="footer-links flex flex-wrap gap-x-4 gap-y-2 text-sm" aria-label="Legal and privacy">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-service">Terms of Service</a>
          <a href="/cookie-policy">Cookie Policy</a>
          <a href="/accessibility">Accessibility</a>
          <a href="/do-not-sell-or-share">Do Not Sell or Share</a>
          <CookieSettingsLink className="underline text-inherit bg-transparent border-0 p-0 cursor-pointer text-sm" />
        </nav>
      </div>
    </footer>
  );
}

export default FooterMain;
